import { render, staticRenderFns } from "./Lux-Voyages-Data.vue?vue&type=template&id=7e6b60f8&"
import script from "./Lux-Voyages-Data.vue?vue&type=script&lang=js&"
export * from "./Lux-Voyages-Data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports